import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-flex h-flex-space-between h-flex-dir-column" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "h-text-center h-mb-20" }
const _hoisted_4 = { class: "b-base-title h-mt-10" }
const _hoisted_5 = { class: "h-mt-10 h-mb-20 h-text-center" }
const _hoisted_6 = { class: "h-flex h-flex-center h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.requireImage("link-sent.svg")
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('AUTH.LINK_SENT.TITLE')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('AUTH.LINK_SENT.ASIDE')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FwButton, {
          class: "h-mt-30",
          borderRadiusType: "small-border",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: "LoginPage" })))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LINK_SENT.BACK')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}